// @greenlight-spec: 19-design-system.md
import * as React from 'react';

import { cn } from '@/lib/utils';

export interface ClaudeMarkProps {
  /** Side in px. Default 14. */
  size?: number;
  className?: string;
}

/**
 * Small Claude attribution mark. Purely decorative — aria-hidden.
 */
export function ClaudeMark({ size = 14, className }: ClaudeMarkProps): React.JSX.Element {
  return (
    <img
      src="/icons/claude.svg"
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      className={cn('inline-block shrink-0', className)}
    />
  );
}
